//export const API_URL = "http://192.168.137.22:8082/api";
//export const VIDEO_STEAM_SERVER_URL = "192.168.137.25";

//export const API_URL = "https://mektep.meria.kg/api";
export const API_URL = "/api";
export const VIDEO_STEAM_SERVER_URL = "online.meria.kg";

export default {API_URL, VIDEO_STEAM_SERVER_URL};
